/**
 * Data collection for individual payments.
 * @type {webix.DataCollection}
 * @property {string} url - The URL to fetch the individual payments data.
 * @property {Object} scheme - The scheme configuration for the data collection.
 * @property {Function} scheme.$init - Function to initialize each data object.
 * @property {Object} obj - The data object being initialized.
 * @property {string} obj.date - The date property of the data object, parsed to the correct format.
 */
export const individualpayments = new webix.DataCollection({
    url: 'data/individualpayments.json',
    scheme: {
        $init: function (obj) {
            obj.date = webix.i18n.parseFormatDate(obj.date);
        },
    },
});

// FILE DOCUMENTED
